export const museumsRToZ = {
  ROSICRUCIAN_EGYPTIAN_MUSEUM: {
    key: 'ROSICRUCIAN_EGYPTIAN_MUSEUM',
    name: 'Rosicrucian Egyptian Museum',
    city: 'San Jose',
    country: 'US',
    url: 'https://egyptianmuseum.org/',
  },
  ROYAL_ONTARIO_MUSEUM: {
    key: 'ROYAL_ONTARIO_MUSEUM',
    name: 'Royal Ontario Museum',
    city: 'Toronto',
    country: 'CA',
    url: 'https://www.rom.on.ca/',
  },
  RYLANDS_INSTITUTE: {
    key: 'RYLANDS_INSTITUTE',
    name: 'John Rylands Research Institute and Library',
    city: 'Manchester',
    country: 'GB',
    url: 'https://www.library.manchester.ac.uk/rylands/',
  },
  SANLIURFA_MUSEUM: {
    key: 'SANLIURFA_MUSEUM',
    name: 'Şanlıurfa Arkeoloji Müzesi',
    city: 'Şanlıurfa',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=SUM02&DistId=SUM',
  },
  SCHOYEN_COLLECTION: {
    key: 'SCHOYEN_COLLECTION',
    name: 'Schøyen Collection',
    city: 'Oslo',
    country: 'NO',
    url: 'https://www.schoyencollection.com/',
  },
  SEPHARDIC_MUSEUM_OF_TOLEDO: {
    key: 'SEPHARDIC_MUSEUM_OF_TOLEDO',
    name: 'Sephardic Museum of Toledo',
    city: 'Toledo',
    country: 'ES',
    url: 'https://www.cultura.gob.es/msefardi/',
  },
  SLEMANI_MUSEUM: {
    key: 'SLEMANI_MUSEUM',
    name: 'Slemani Museum',
    city: 'Sulaymaniyah',
    country: 'IQ',
    url: 'https://slemanimuseum.org/',
  },
  SPURLOCK_MUSEUM: {
    key: 'SPURLOCK_MUSEUM',
    name: 'Spurlock Museum, University of Illinois',
    city: 'Urbana-Champaign',
    country: 'US',
    url: 'https://www.spurlock.illinois.edu/',
  },
  STAATLICHES_MUSEUM_AEGYPTISCHER_KUNST: {
    key: 'STAATLICHES_MUSEUM_AEGYPTISCHER_KUNST',
    name: 'Staatliches Museum Ägyptischer Kunst',
    city: 'Munich',
    country: 'DE',
    url: 'https://smaek.de/',
  },
  THE_BRITISH_MUSEUM: {
    key: 'THE_BRITISH_MUSEUM',
    name: 'The British Museum',
    city: 'London',
    country: 'GB',
    url: 'https://www.britishmuseum.org/',
    copyright:
      '© [The Trustees of the British Museum](https://www.britishmuseum.org/about_this_site/terms_of_use/copyright_and_permissions.aspx), [CC-BY-NC-SA 4.0](https://creativecommons.org/licenses/by-nc-sa/4.0/)',
  },
  THE_FIELD_MUSEUM_OF_NATURAL_HISTORY: {
    key: 'THE_FIELD_MUSEUM_OF_NATURAL_HISTORY',
    name: 'The Field Museum of Natural History',
    city: 'Chicago',
    country: 'US',
    url: 'https://www.fieldmuseum.org/',
  },
  THE_FREE_LIBRARY_OF_PHILADELPHIA: {
    key: 'THE_FREE_LIBRARY_OF_PHILADELPHIA',
    name: 'The Free Library of Philadelphia',
    city: 'Philadelphia',
    country: 'US',
    url: 'https://www.freelibrary.org/',
  },
  THE_IRAQ_MUSEUM: {
    key: 'THE_IRAQ_MUSEUM',
    name: 'The Iraq Museum',
    city: 'Baghdad',
    country: 'IQ',
    url: 'https://theiraqmuseum.com/',
    copyright:
      'By Permission of the State Board of Antiquities and Heritage and The Iraq Museum',
  },
  THE_METROPOLITAN_MUSEUM_OF_ART: {
    key: 'THE_METROPOLITAN_MUSEUM_OF_ART',
    name: 'The Metropolitan Museum of Art',
    city: 'New York',
    country: 'US',
    url: 'https://www.metmuseum.org/',
  },
  THE_WALTERS_ART_MUSEUM: {
    key: 'THE_WALTERS_ART_MUSEUM',
    name: 'The Walters Art Museum',
    city: 'Baltimore',
    country: 'US',
    url: 'https://thewalters.org/',
  },
  TOPKAPI_SARAYI: {
    key: 'TOPKAPI_SARAYI',
    name: 'Topkapı Sarayı Müzesi',
    city: 'Istanbul',
    country: 'TR',
    url: 'https://muze.gen.tr/muze-detay/topkapi',
  },
  TRINITY_COLLEGE_DUBLIN: {
    key: 'TRINITY_COLLEGE_DUBLIN',
    name: 'Trinity College Dublin',
    city: 'Dublin',
    country: 'IE',
    url: 'https://www.tcd.ie/',
  },
  TURIN_DEPARTMENT_ARCHAEOLOGY: {
    key: 'TURIN_DEPARTMENT_ARCHAEOLOGY',
    name: 'Sezione di Archeologia del Dipartimento di Studi Storici, Università di Torino',
    city: 'Turin',
    country: 'IT',
    url: 'https://www.dipstudistorici.unito.it/',
  },
  UNKNOWN: { key: 'UNKNOWN', name: '', city: '', country: '' },
  URUK_WARKA_SAMMLUNG: {
    key: 'URUK_WARKA_SAMMLUNG',
    name: 'Uruk-Warka-Sammlung',
    city: 'Heidelberg',
    country: 'DE',
    url: 'https://www.ori.uni-heidelberg.de/assyriologie/institut/sammlungen/sa-uw.html',
  },
  VATICAN_MUSEUMS: {
    key: 'VATICAN_MUSEUMS',
    name: 'Vatican Museums',
    city: 'Vatican City',
    country: 'VA',
    url: 'http://www.museivaticani.va/',
  },
  VORDERASIATISCHES_MUSEUM: {
    key: 'VORDERASIATISCHES_MUSEUM',
    name: 'Vorderasiatisches Museum',
    city: 'Berlin',
    country: 'DE',
    url: 'https://www.smb.museum/en/museums-institutions/vorderasiatisches-museum/home/',
    copyright:
      'Credit: Staatliche Museen zu Berlin, Vorderasiatisches Museum, [CC-BY-SA 4.0](https://creativecommons.org/licenses/by-sa/4.0/)',
  },
  YALE_PEABODY_COLLECTION: {
    key: 'YALE_PEABODY_COLLECTION',
    name: 'Yale Peabody Museum, Yale Babylonian Collection',
    city: 'New Haven',
    country: 'US',
    url: 'https://peabody.yale.edu/explore/collections/yale-babylonian-collection',
  },
} as const
